<template>
    <div class="noticeCount cursor-pointer" @click="showFilterMenu">
        <el-icon ><search /></el-icon>
    </div>
    <el-dialog 
        @opened="showSuggest"
        class="qwe-el-dialog site-search"
        v-model="dialogVisible"
        title="Tips">
        <el-autocomplete
            ref="siteSearch"
            v-model="filter"
            :fetch-suggestions="querySearch"
            clearable
            placeholder="搜索功能"
            @select="handleSelect">
            <template #prefix>
                <el-icon class="el-input__icon" >
                    <search />
                </el-icon>
            </template>
            <template #default="{ item }">
                {{ item.DisplayName }}
            </template>
        </el-autocomplete>
    </el-dialog>
</template>

<style>
    :root{
        --search-tool-line-height:60px;
    }

    .qwe-el-dialog{
        border-radius: 5px !important;
        padding: 0px !important;
    }

    .el-dialog.qwe-el-dialog.site-search>.el-dialog__header{
        display: none;
    }
    
    .el-dialog.qwe-el-dialog>.el-dialog__body{
        padding-left: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-right: 0px;
        display: flex;
        align-items: center;
    }

    .site-search .el-autocomplete{
        width: 100%;
    }

    .site-search .el-autocomplete input{
        height: 100%;
    }

    .site-search .el-input.el-input--prefix.el-input--suffix{
        line-height: var(--search-tool-line-height) !important;
        height: var(--search-tool-line-height);
    }

    .site-search .el-input__wrapper{
        padding-left: 24px;
        padding-right: 24px;
        border: 0px !important;
        box-shadow:none !important
    }

    .site-search .el-input__wrapper:hover {
        box-shadow: none;
    }

    .site-search .el-icon.el-input__icon{
        line-height: 17px;
    }
</style>

<script>
    import { Search } from '@element-plus/icons-vue'
    export default {
        data:function(){
            return {
                dialogVisible:false,
                showSuggestion:false,
                suggestions:[],
                filter:""
            }
        },

        components:{
            "search":Search
        },  

        methods:{
            showSuggest:function(){
                console.log(this.$refs.siteSearch.focus())
            },

            querySearch:function(value, cb){
                let suggestions = this.$store.state.flatMenuItems.filter(x=> x.DisplayName.includes(value));
                cb(suggestions);
            },

            showFilterMenu:function(){
                this.filter = "";
                this.dialogVisible = true;
                this.suggestions = this.$store.state.flatMenuItems.filter(x=>true);
            },

            changefilter:function(e){
                this.suggestions = this.$store.state.flatMenuItems.filter(x=> x.DisplayName.includes(e.target.value));
            },

            closeFilterMenu:function(){
                this.dialogVisible = false;
                this.showSuggestion = false;
            },

            handleSelect:function(item){
                this.dialogVisible = false;
                this.$router.push(item.Path);
            },
        }
    }
</script>